import { render, staticRenderFns } from "./tgfy_add.vue?vue&type=template&id=16afda47&scoped=true&"
import script from "./tgfy_add.vue?vue&type=script&lang=js&"
export * from "./tgfy_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16afda47",
  null
  
)

export default component.exports